import {
  Button,
  Pagination,
  Popconfirm,
  Select,
  Spin,
  Table,
  Tag,
  Input,
  message,
  Flex,
  Radio,
  Image,
} from "antd";
import React, { useEffect, useState } from "react";

import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";

import ComponentTitle from "../../../Common/ComponentTitle";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import "animate.css";
import AddBanner from "./AddBanner";
import { deleteBanner, getBannerDetails } from "./BannerApi";
const BannerDetails = () => {
  const [bannerData, setbannerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [from, setFrom] = useState("category");
  const [filldata, setFilldata] = useState({});
  const [action, setAction] = useState("");
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [approved, setApproved] = useState(0);
  const [rejected, setRejected] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  const pageSize = 10;
  function FetchBannerDetails(currentPage) {
    setIsLoading(true);
    getBannerDetails(`name=${searchTerm}&page=${currentPage}&limit=10`)
      .then((response) => {
        if (response.data.status) {
          setbannerData(response.data?.data);
          setCurrentPage(response.data?.pagination?.currentPage);
          setTotalPages(response.data?.pagination?.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }
  function DeleteAction(checked, record) {
    deleteBanner(`${record.id}`)
      .then((response) => {
        if (response.data.status) {
          message.open(
            messageConfiguration("success", response.data.message, 3)
          );
          FetchBannerDetails(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    FetchBannerDetails(currentPage);
  }, [currentPage, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  const setwithdrawAction = (id, value) => {
    setAction((prevAction) => ({
      ...prevAction,
      [id]: value,
    }));
  };

  const columns = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },
    {
      title: "Banner",
      dataIndex: "name",
      key: "name",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <Image
              src={`${process.env.REACT_APP_IMAGE_URL}${record.image_path}`}
              height={100}
              width={200}
            />
          </>
        );
      },
    },
    {
      title: "Banner Type",
      dataIndex: "type",
      key: "type",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <Tag className="text-xs font-poppins uppercase rounded-none bg-rgbaprimary9  text-white font-bold" >
              {record.type ?? "--"}
            </Tag>
          </>
        );
      },
    },
    // {
    //   title: "Icon Image",
    //   dataIndex: "iconImage",
    //   key: "iconImage",
    //   className: "custom-header font-poppins text-xs",
    //   render: (data, record) => {
    //     return (
    //       <>
    //         <Image
    //           height={40}
    //           width={40}
    //           src={`${process.env.REACT_APP_IMAGE_URL}${record.iconImage}`}
    //           className="text-xs font-poppins"
    //         />
    //         {/* <p className="text-xs font-poppins">{record.iconImage ?? "--"}</p> */}
    //       </>
    //     );
    //   },
    // },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <EditOutlined
              className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
              onClick={() => {
                setOpenModal(true);
                setFrom("edit");
                setFilldata(record);
              }}
            />
          </>
        );
      },
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Popconfirm
          title={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Are you sure you want to delete this Banner?
              </p>
            </div>
          }
          onConfirm={() => DeleteAction(undefined, record)}
          okText="Delete"
          cancelText="Cancel"
        >
          <DeleteOutlined
            className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
            title="Delete"
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <ComponentTitle title={"Banner List"} />
      <div className="flex items-end justify-end mb-4">
        <p
          onClick={() => {
            setOpenModal(true);
            setFrom("add");
          }}
          className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary5"
        >
          Create Banner
        </p>
      </div>

      <div
        style={{ maxHeight: "500px", overflow: "auto" }}
        className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
      >
        <Table
          bordered={true}
          columns={columns}
          loading={isLoading}
          dataSource={bannerData}
          pagination={false}
          className="w-screen sm:w-screen custom-table-header"
          size="small"
        />
      </div>
      <Pagination
        className="mt-2  w-full flex justify-center items-center "
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        total={10 * totalPage}
        showSizeChanger={false}
        pageSize={pageSize}
      />
      {openModal && (
        <AddBanner
          isOpen={openModal}
          setIsOpen={setOpenModal}
          Fill={filldata}
          setFill={setFilldata}
          from={from}
          current={currentPage}
          apiCall={FetchBannerDetails}
        />
      )}
    </div>
  );
};
export default BannerDetails;
